import { ReactComponent as CircleCheck } from "assets/images/lps-circlecheck.svg";
import { ReactComponent as CircleCheckOuter } from "assets/images/lps-circlecheckouter.svg";
import Footer from "components/footer/Footer";
import LoanOfficerCard from "components/v2/loan-officer-card/LoanOfficerCard";
import LoanOfficerCardV2 from "components/v2/loan-officer-card/LoanOfficerCardV2";
import useDesktopChecker from "hooks/useDesktopChecker";
import { LoanOfficerDetail } from "pages/application/applicationService";
import "./LpsThankyou.scss";

interface LPSThankYouProps {
	loanOfficer?: LoanOfficerDetail;
	loanOfficerName?: string;
}

export default function LPSThankYou({
	loanOfficer,
	loanOfficerName,
}: Readonly<LPSThankYouProps>) {
	const displayName = loanOfficerName ?? loanOfficer?.fullName ?? "Your Loan Officer";
	const isDesktop = useDesktopChecker();

	return (
		<div className="lps-thankyou-page">
			<div className="lps-thankyou-page__main">
				<section className="lps-thankyou" aria-labelledby="lps-thankyou-heading">
					<div className="lps-thankyou__icon" aria-hidden="true">
						<CircleCheckOuter className="lps-thankyou__icon-outer" />
						<CircleCheck className="lps-thankyou__icon-check" />
					</div>

					<h1 id="lps-thankyou-heading" className="lps-thankyou__title">
						Thank You!
					</h1>

					<p className="lps-thankyou__description">
						<span>Your application has been received. Your loan officer, </span>
						<span className="lps-thankyou__officer-name">{displayName}</span>
						<span>
							{", will review it and contact you with the next steps to move forward with your application."}
						</span>
					</p>
				</section>

				{loanOfficer && (
					<section className="lps-thankyou-page__lo-card" aria-label="Loan officer information">
						{isDesktop ? (
							<LoanOfficerCardV2 loInfo={loanOfficer} />
						) : (
							<LoanOfficerCard loInfo={loanOfficer} hideLabel />
						)}
					</section>
				)}
			</div>

			<div className="lps-thankyou-page__footer">
				<Footer />
			</div>
		</div>
	);
}
